import { ENV, isRealProd, EnvTypes, MARKETING } from '../env';

// // 线上使用的
// const hqApiOnline = 'https://hq-web-api.global.mplusonline.com';
// const hqApiHK = 'https://hqwebapi.hstong.com';
// const webApiOnline = 'https://web-api.mplusglobal.com.my';
// const financeApiOnline = 'https://finance-web-api.mplusglobal.com.my';
// const financeApiOnlineHk = 'https://web-api.vbkr.com';

// 不同展业地的
const getBaseApiDomain = (env: EnvTypes | string, market?: string) => {
	if (market === 'MY') {
		return isRealProd
			? `https://web-api.global.mplusonline.com`
			: `https://web-api-${env}.mplusglobal.com.my`;
	} else {
		const url = window.location.href.includes('vbkr')
			? `https://web-api-g-${env}.vbkr.com`
			: `https://web-api-g-${env}.hstong.com`;
		return url.replace('web-api-g-prod', 'web-api-g');
	}
};

const getLoginApiDomain = (env: EnvTypes | string, market?: string) => {
	if (market === 'MY') {
		return isRealProd
			? `https://web-api.global.mplusonline.com`
			: `https://web-api-${env}.mplusglobal.com.my`;
	} else {
		const url = window.location.href.includes('vbkr')
			? `https://web-api-${env}.vbkr.com`
			: `https://web-api-${env}.hstong.com`;
		return url.replace('web-api-prod', 'web-api');
	}
};
// const getOpenAppUrl = (env: EnvTypes | string, market?: string) => {
// 	if (market === 'HK') {
// 		return isRealProd
// 			? 'https://h5.hstong.com/vip/gift/index'
// 			: 'https://h5daily.hstong.com/vip/gift/index';
// 	} else if (market === 'MY') {
// 		return isRealProd
// 			? 'https://m.global.mplusonline.com/openapp'
// 			: 'https://feature.mplusglobal.com.my/openapp';
// 	}
// };

const getDiscountUrl = (market?: string) => {
	if (market === 'HK') {
		return isRealProd
			? 'https://h5.hstong.com/vip/gift/index'
			: 'https://h5daily.hstong.com/vip/gift/index';
	} else if (market === 'MY') {
		return isRealProd
			? 'https://m.global.mplusonline.com/m/coupon'
			: 'https://m-feature.mplusglobal.com.my/m/coupon';
	}
};

/**
 * 香港主站获取资讯host方法
 * @param env 环境
 * @param market 展业地
 * @returns
 */
const getNewsHost = (env: EnvTypes | string, market?: string) => {
	if (market === 'HK') {
		const newsUrlInfo = {
			prod: 'https://news.hstong.com',
			feature: 'https://newsfeature.hstong.com',
			daily: 'https://newsdaily.hstong.com',
		};
		return newsUrlInfo[env] || 'https://newsfeature.hstong.com';
	}
};

/**
 * 香港主站获取行情host方法
 * @param env 环境
 * @param market 展业地
 * @returns
 */
const getHqWebApi = (env: EnvTypes | string, market?: string) => {
	if (market === 'HK') {
		const newsUrlInfo = {
			prod: 'https://hqwebapi.hstong.com',
			feature: 'https://hqwebapi-daily.hstong.com',
			daily: 'https://hqwebapi-daily.hstong.com',
			beta: 'https://hqwebapi-beta.hstong.com',
		};
		return newsUrlInfo[env] || 'https://hqwebapi-daily.hstong.com';
	}
};

const getDomains = () => {
	return {
		baseApi: getBaseApiDomain(ENV, MARKETING),
		loginApi: getLoginApiDomain(ENV, MARKETING),
		discount: getDiscountUrl(MARKETING),
		newsHost: getNewsHost(ENV, MARKETING),
		hqWebApi: getHqWebApi(ENV, MARKETING),
	};
};

const DomiansOfBusiness = getDomains();

export default DomiansOfBusiness;
